import { request, versionRequest } from '@/service/request';

// =============== User Begin ===============

/** get user list */
export function fetchGetUserList(params?: Api.SystemManage.UserSearchParams) {
  return versionRequest<Api.SystemManage.UserList>({
    url: '/sys_user/page',
    method: 'GET',
    params
  });
}

export function fetchAllUserList(orgCode?: string) {
  return versionRequest<Api.SystemManage.UserList>({
    url: `/sys_user/all/${orgCode || 'default'}`,
    method: 'GET'
  });
}

/** user drawer get user info */
export function fetchGetEditUserInfo(id: string) {
  return versionRequest<Api.SystemManage.User>({
    url: `/sys_user/${id}`,
    method: 'GET'
  });
}

/** add user info */
export function fetchAddUser(data: Api.SystemManage.UserEdit) {
  return versionRequest<boolean>({
    url: '/sys_user/',
    method: 'POST',
    data
  });
}

/** edit update user info */
export function fetchUpdateUserInfo(data: Api.SystemManage.UserEdit) {
  return versionRequest<boolean>({
    url: '/sys_user/',
    method: 'PUT',
    data
  });
}

/** edit delete user */
export function fetchDeleteUser(data: Api.Common.DeleteParams) {
  return versionRequest<boolean>({
    url: '/sys_user/',
    method: 'DELETE',
    data
  });
}

export function fetchResetUserPassword(userId: string, newPassword: string) {
  return versionRequest({
    url: `/sys_user/reset_password/${userId}`,
    method: 'PUT',
    data: newPassword,
    headers: {
      'Content-Type': 'text/plain'
    }
  });
}

/** get user responsibilities */
export function fetchGetUserResponsibilities(userId: string) {
  return versionRequest<Api.SystemManage.UserResponsibilities>({
    url: `/sys_user/responsibilities/${userId}`,
    method: 'GET'
  });
}

/** get user responsibilities */
export function fetchSaveUserResponsibilities(data: Api.SystemManage.UserResponsibilities) {
  return versionRequest<boolean>({
    url: `/sys_user/responsibilities`,
    method: 'PUT',
    data
  });
}

/** set user org units （new） */
export function fetchSetUserOrgUnits(data: Api.SystemManage.UserOrgUnits) {
  return versionRequest<boolean>({
    url: `/sys_user/org_code`,
    method: 'PUT',
    data
  });
}

/** set user org units （new） */
export function fetchReadOrgUnits(userId: string) {
  return versionRequest<boolean>({
    url: `/api/v1/supplychain/relation/user-permission/read-permissions/${userId}`,
    method: 'GET'
  });
}

// =============== User End  ===============
